<template>
  <div class="ui left aligned container">
    <vuetable ref="vuetable"
              api-url="/weibo/stats"
              :fields="fields"
              :perPage="12"
              :sort-order="sortOrder"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
    <div>
      <br/>
      <a href="https://weibo.com/u/5644764907" target="_blank"> 杨超越微博 </a>
      <a href="https://weibo.com/u/7447677038" target="_blank"> 杨超越工作室 </a>
      <a href="https://m.oasis.weibo.cn/v1/h5/share?uid=5644764907" target="_blank"> 杨超越绿洲 </a>
      <a href="https://weibo.com/p/1008082a98366b6a3546bd16e9da0571e34b84/super_index" target="_blank"> 杨超越超话 </a>
      <a href="https://weibo.com/p/1008087821b5ece37a6b97f355768b685ff56c/super_index" target="_blank"> 海底捞越 </a>
      <router-link to="/weibo" v-if="user.authenticated"> 微博存档 </router-link>
    </div>
    <div class="ui hidden divider"></div>
    <div class="row">
      <date-picker range valueType="format" @clear="range=[]" v-model="range"></date-picker>
      <button class="ui load button" @click="load">Load</button>
    </div>
    <div class="ui form">
      <div class="inline fields">
        <label>间隔</label>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="1" v-model="interval" @change="load()">
            <label>1小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="24" v-model="interval" @change="load()">
            <label>24小时</label>
          </div>
        </div>
      </div>
    </div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>
<style>
.ui.load.button {
  margin-left: 12px;
}
</style>
<script>
  import Vuetable from '../table/Vuetable.vue'
  import VuetablePagination from '../table/VuetablePagination.vue'
  import axios from 'axios'
  import ECharts from 'vue-echarts'
  import auth from '@/services/Auth'
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'WeiboStats',
    components: {
      Vuetable,
      VuetablePagination,
      DatePicker,
      'v-chart': ECharts
    },
    data () {
      return {
        fields: [
          {name: 'time', title: '时间', callback: 'localTime'},
          {name: 'followersCount', title: '粉丝数'},
          {name: 'statusesCount', title: '微博数'},
          {name: 'followCount', title: '关注数'},
          {name: 'repostCount', title: '转发量'},
          {name: 'commentCount', title: '评论量'},
          {name: 'likeCount', title: '获赞'},
          {name: 'totalCount', title: '转评赞'},
          {name: 'urank', title: '等级'},
        ],
        user: {},
        interval: 1,
        page: 0,
        range: [],
        options: null,
        sortOrder: [
          {
            field: 'time',
            direction: 'desc'
          }
        ]
      }
    },
    mounted () {
      this.user = auth.user;
      this.load();
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        if (page === 'prev') {
          this.page--
        } else if (page === 'next') {
          this.page++
        } else {
          this.page = parseInt(page)
        }
        this.range = [];
        this.load();
        this.$refs.vuetable.changePage(page)
      },
      load: function () {
        let page = Math.floor(this.page / this.interval);
        let api = '/weibo/stats/chart?size=12&page=' + page + '&interval=' + this.interval
        if (this.range.length === 2) {
          api = `/weibo/stats/chart?start=${this.range[0]}&end=${this.range[1]}&interval=${this.interval}`
        }
        axios.get(api).then(response => {
          this.options =
              {
                title: {
                  text: '增幅'
                },
                tooltip: {
                  trigger: 'axis'
                },
                legend: {
                  data: ['粉丝增长', '转发增长', '评论增长', '获赞增长']
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                xAxis: {
                  type: 'time'
                },
                yAxis: {
                  type: 'value'
                },
                series: [
                  {
                    name: '粉丝增长',
                    type: 'line',
                    data: response.data.map(e => [e.time, e.followersCount])
                  },
                  {
                    name: '转发增长',
                    type: 'line',
                    data: response.data.map(e => [e.time, e.repostCount])
                  },
                  {
                    name: '评论增长',
                    type: 'line',
                    data: response.data.map(e => [e.time, e.commentCount])
                  },
                  {
                    name: '获赞增长',
                    type: 'line',
                    data: response.data.map(e => [e.time, e.likeCount])
                  }
                ]
              };
        });
      },
      localTime (value) {
        return new Date(value).toLocaleString()
      }
    }
  }
</script>
